export default __webpack_public_path__ + "static/media/freeWifi.1eefee0f.svg";